import { render, staticRenderFns } from "./FrameSelection.vue?vue&type=template&id=4cf37410&scoped=true&"
import script from "./FrameSelection.vue?vue&type=script&lang=js&"
export * from "./FrameSelection.vue?vue&type=script&lang=js&"
import style0 from "./FrameSelection.vue?vue&type=style&index=0&id=4cf37410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf37410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDatePicker,VDialog,VIcon,VMenu,VSelect})
